export function exists<T>(value: undefined | null | T): value is T {
  if (value === undefined || value === null) return false
  return true
}
